<template>
  <div class="animated fadeIn border-bottom mb-3">
    <b-form-group :label="`Question #${(parseInt(index) + 1)}`">
      <b-row>
        <b-col class="pr-0">
          <b-form-select
            v-model="type_data"
            :options="type_options"
            :value="type_data"
            placeholder="Question Type"
            @input="updateQuestion"
          />
        </b-col>
        <b-col>
          <div class="input-group mb-3">
            <b-form-input
              v-model="label_data"
              placeholder="Question Label"
              @input="updateQuestion"
            />
            <div class="input-group-append">
              <b-button
                title="Remove question"
                variant="outline-danger"
                @click="deleteQuestion"
              >
                <i class="fal fa-times" />
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
      <template v-if="showValuesInput()">
        <b-form-group
          description="Define comma separated options available when answering the question"
        >
          <b-form-input
            v-model="values_data"
            placeholder="Value1, Value 2, Value 3"
            @input="updateQuestion"
          />
        </b-form-group>
      </template>
    </b-form-group>
  </div>
</template>

<script>

export default {
  name: "ServiceQuestionInputRow",
  components: {},
  props: {
    laboratory: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    sample_type: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    question: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    form_level: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      label_data: "",
      type_data: "",
      values_data: "",
      question_types: {
        checkboxes: {
          name: "Checkboxes",
          include_values: true
        },
        number: {
          name: "Number Input",
          include_values: false
        },
        select: {
          name: "Select Dropdown",
          include_values: true
        },
        text: {
          name: "Text Input",
          include_values: false
        }
      },
      type_options: []
    };
  },
  methods: {
    splitQuestionData() {
      if (Object.entries(this.question).length !== 0) {
        this.label_data = this.question.label;
        this.type_data = this.question.input_type;
        this.values_data = this.question.values;
      } else {
        this.type_data = "";
      }
    },
    setTypeOptions() {
      this.type_options.push({
        value: "",
        text: " - Question Type - "
      });
      Object.entries(this.question_types).forEach(([key, value]) => {
        this.type_options.push({
          value: key,
          text: value.name
        });
      });
    },
    showValuesInput() {
      if (
        typeof this.type_data === "undefined" ||
        this.type_data.length === 0
      ) {
        return false;
      }

      return this.question_types[this.type_data].include_values;
    },
    updateQuestion() {
      this.$emit("updateQuestion", {
        index: this.index,
        id: this.question.id,
        input_type: this.type_data,
        label: this.label_data,
        values: this.values_data
      });
    },
    deleteQuestion() {
      this.$emit("deleteQuestion", this.question);
    }
  },
  watch: {
    question: {
      handler() {
        this.splitQuestionData();
      },
      deep: true
    }
  },
  mounted() {
    // initialize data
    this.setTypeOptions();
    this.splitQuestionData();
  }
};
</script>
